import { useRef, useCallback } from "react";
import { useFocusEffect } from "@react-navigation/native";

import { AppState } from "react-native";
import { trackScreenTime } from "./analyticsUtil";

export function useTrackScreenTime(screenName: string) {
  const startTimeRef = useRef<number | null>(null);
  const appState = useRef(AppState.currentState);

  useFocusEffect(
    useCallback(() => {
      startTimeRef.current = Date.now();

      const sub = AppState.addEventListener("change", nextState => {
        if (appState.current === "active" && nextState !== "active") {
          // app going to background → pause
          if (startTimeRef.current) {
            const durationMs = Date.now() - startTimeRef.current;
            trackScreenTime(screenName, durationMs, { reason: "background" });
            startTimeRef.current = null;
          }
        }

        if (appState.current !== "active" && nextState === "active") {
          // app back → resume
          startTimeRef.current = Date.now();
        }

        appState.current = nextState;
      });

      return () => {
        sub.remove();
        if (!startTimeRef.current) return;
        const durationMs = Date.now() - startTimeRef.current;
        trackScreenTime(screenName, durationMs);
        startTimeRef.current = null;
      };
    }, [screenName])
  );
}
